import jQuery from 'jquery';

jQuery(($) => {
  'use strict';

  let statusTable = $('#statusTable');

  if (statusTable.length > 0) {
    $('body').on('click', '.open-child-table', (e) => e.preventDefault());

    statusTable.jtable({
      title: 'Requests by Name on Record',
      paging: true, //Enable paging
      pageSize: 25, //Set page size (default: 10)
      sorting: true,
      saveUserPreferences: false,
      defaultSorting: 'nor ASC',
      actions: {
        listAction: window.statusBaseUrl + '/requests'
      },
      fields: {
        nor_id: {
          title: 'ID',
          key: true,
          list: true,
          width: '12%',
          edit: false,
          create: false,
          display: (data) => {
            // Create a link that will be used to open child table
            let $link = $('<img src="' + window.plusIconUrl +
              '" width="12" height="12">  <a href="#" class="open-child-table">VIEW REQUESTS</a>');

            // Open child table when user clicks the image
            $link.click(() => {
              statusTable.jtable('openChildTable', $link.closest('tr'), {
                title: data.record.nor + ':    Requests',
                sorting: true,
                defaultSorting: 'deponent_name ASC',
                actions: {
                  listAction: window.statusBaseUrl + '/requests/' + data.record.nor_id
                },
                fields: {
                  invoice_number: {
                    title: 'Invoice #',
                    width: '9%'
                  },
                  deponent_name: {
                    title: 'Deponent Name',
                    width: '20%'
                  },
                  fka_notes: {
                    title: 'F.K.A./Notes',
                    width: '20%'
                  },
                  date_printed: {
                    title: 'Entered'
                  },
                  date_auth_printed: {
                    title: 'Auth Sent'
                  },
                  date_auth_received: {
                    title: 'Auth Rcvd'
                  },
                  date_subpoena_printed: {
                    title: 'Subp Sent'
                  },
                  date_subpoena_due: {
                    title: 'Subp Due'
                  },
                  date_received: {
                    title: 'Rcvd In'
                  }
                }
              }, (data) => {
                data.childTable.jtable('load');
              });
            });

            return $link;
          }
        },
        nor: {
          title: 'Name on Record',
          width: ' 18%'
        },
        requestor: {
          title: 'Requested By',
          width: ' 18%'
        },
        case_num: {
          title: 'Case Number'
        },
        file_num: {
          title: 'File Number'
        },
        claim_num: {
          title: 'Claim Number'
        }
      }
    });

    // Load all records when page is first shown
    statusTable.jtable('load');
  }
});